import Player from 'features/player';

import { useJourneys } from 'features/journeys';
import { Flex, Modal, Typography } from 'components';
import { VideoProviderEnum } from 'features/contents';
import { useMemo } from 'react';

const VideoPlayer = () => {
  const { journeyVideoPlayer, clearJourneyVideoPlayer } = useJourneys();

  const showPlayer = useMemo(() => {
    if (journeyVideoPlayer?.videoProvider === VideoProviderEnum.ProtectedVideo && !journeyVideoPlayer?.protectedVideoOtp) {
      return false;
    }

    if (journeyVideoPlayer?.videoProvider === VideoProviderEnum.Panda && !journeyVideoPlayer?.protectedVideoPlaybackInfo) {
      return false;
    }

    return true;
  }, [journeyVideoPlayer]);

  return journeyVideoPlayer ? (
    <Modal onClose={clearJourneyVideoPlayer}>
      <Flex width={{ m: 320, t: 640, d: 800 }} height={{ m: 180, t: 360, d: 576 }}>
        {showPlayer ? (
          <Player
            videoProvider={journeyVideoPlayer.videoProvider}
            externalVideoProviderIdOrUrl={journeyVideoPlayer.externalVideoProviderIdOrUrl}
            protectedVideoOtp={journeyVideoPlayer.protectedVideoOtp}
            protectedVideoPlaybackInfo={journeyVideoPlayer.protectedVideoPlaybackInfo}
            protectedVideoPlayerTheme={journeyVideoPlayer.protectedVideoPlayerTheme}
            width={{ m: 320, t: 640, d: '100%' }}
            height={{ m: 180, t: 360, d: 576 }}
            maxWidth={{ d: 1024 }}
            maxHeight={{ d: 576 }}
          />
        ) : (
          <Flex alignItems="center" justifyContent="center">
            <Typography type="type6" fontWeight="bold" color="alert_400">
              Ocorreu um erro ao reproduzir vídeo.
            </Typography>
          </Flex>
        )}
      </Flex>
    </Modal>
  ) : (
    <></>
  );
};

export default VideoPlayer;
